module.exports = __webpack_public_path__ + "public/adminIcons/last30dayslistings.svg?97e4665a";